export default __webpack_public_path__ + "static/media/pic35-before.66d47f2c.jpg";